import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import bqtLogo from "../logo/bqt_logo.png";

const year = new Date().getFullYear();

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        borderTop: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
        py: 2.5,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        sx={{ px: { xs: 2, md: 4 } }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            component="img"
            src={bqtLogo}
            alt="Barquecon Technologies"
            sx={{ height: 24, width: "auto", opacity: 0.85 }}
          />
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            © {year} Barquecon Technologies Pvt Ltd. All rights reserved.
          </Typography>
        </Stack>

        <Stack direction="row" spacing={3}>
          <Link
            component={RouterLink}
            to="/terms-of-use"
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: 600 }}
          >
            Terms
          </Link>
          <Link
            component={RouterLink}
            to="/privacy-policy"
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: 600 }}
          >
            Privacy
          </Link>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Footer;
